import {http, onSuccess, onFail} from './http';

export const activityTopGet = (eventKey, params) =>
    http.get(`/api/player/event/${eventKey}/activity/top`, {params})
        .then(onSuccess, onFail);

export const activityTopGetCalculated = (eventKey) =>
    http.get(`/api/player/event/${eventKey}/activity/top/calculated`)
        .then(onSuccess, onFail);

export const activityTopCalculate = (eventKey) =>
    http.post(`/api/player/event/${eventKey}/activity/top/calculate`)
        .then(onSuccess, onFail);
